/* ============================================================
   Charme Bois v2 — Homepage fixes JS (audit Claude)
   Charger en defer dans theme.liquid
   ============================================================ */
(function () {
  'use strict';

  // ----- 1. REVEAL ANIMATIONS au scroll -----
  function initRevealAnimations() {
    // Ne pas executer si reduce motion
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      document.querySelectorAll('[data-reveal]').forEach(function (el) {
        el.classList.add('cb-section--revealed');
      });
      return;
    }

    // Selecteurs des sections a animer
    var selectors = [
      '.cb-section',
      '.cb-quote-block',
      '.cb-newsletter-block',
      '.cb-section-commitments'
    ];
    var sections = document.querySelectorAll(selectors.join(','));

    // Marquer chaque section avec data-reveal pour le CSS
    sections.forEach(function (section) {
      // Exclure le hero (a sa propre animation au load)
      if (section.classList.contains('cb-hero')) return;
      section.setAttribute('data-reveal', '');
    });

    // Fallback si IntersectionObserver indisponible
    if (!('IntersectionObserver' in window)) {
      sections.forEach(function (el) {
        el.classList.add('cb-section--revealed');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('cb-section--revealed');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.12,
      rootMargin: '0px 0px -80px 0px'
    });

    sections.forEach(function (section) {
      if (section.classList.contains('cb-hero')) return;
      observer.observe(section);
    });
  }

  // ----- INIT -----
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRevealAnimations);
  } else {
    initRevealAnimations();
  }
})();
